import {
  UPDATE_PASSWORD,
  UPDATE_PASSWORD_SUCCESSFUL,
  UPDATE_PASSWORD_FAILED
} from "./actionTypes";

const initialState = {
  message: null,
  loading: false,
  user: null,
  success: false,
  error: false
};

const UpdatePassword = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PASSWORD:
      state = {
        ...state,
        loading: true,
        message: null,
      };
      break;
    case UPDATE_PASSWORD_SUCCESSFUL:
      state = {
        ...state,
        loading: false,
        user: action.payload.data,
        success: true,
        message: null,

      };
      break;
    case UPDATE_PASSWORD_FAILED:
      state = {
        ...state,
        user: null,
        loading: false,
        message: action.payload,
        error: true
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default UpdatePassword;
